export async function getRecaptchaToken(action = "general") {
  const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
  if (!siteKey) throw new Error("Missing NEXT_PUBLIC_RECAPTCHA_SITE_KEY");

  // Wait for the reCAPTCHA script to be ready
  await new Promise((resolve) => {
    if (window.grecaptcha?.ready) {
      window.grecaptcha.ready(resolve);
    } else {
      // Poll very briefly if Script hasn't attached yet
      const timer = setInterval(() => {
        if (window.grecaptcha?.ready) {
          clearInterval(timer);
          window.grecaptcha.ready(resolve);
        }
      }, 50);
    }
  });

  const token = await window.grecaptcha.execute(siteKey, { action });
  return token;
}
